<template>
  <div class="reward-wrap">
    <back-button :tag="false" />
    <div class="reward-overview">
      <div class="overview-label">累计中奖金额</div>
      <div class="overview-count">{{ money_total }}元</div>
    </div>
    <div class="reward-label">中奖明细</div>
    <empty v-if="loading === false && list.length === 0" />
    <template v-else>
      <div class="custom-table">
        <div class="custom-tbody">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getData"
          >
            <van-row v-for="(item, index) in list" :key="index">
              <van-col span="12">
                <div class="amount-label">抽中红包</div>
                <div class="amount-time">
                  {{ item.create_time | datetimeFormat("YYYY-MM-DD HH:mm") }}
                </div>
              </van-col>
              <van-col span="12" class="amount-value right"
                >+{{ item.money }}</van-col
              >
            </van-row>
          </van-list>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Empty from "./Empty";
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    Empty,
    BackButton,
  },
  data() {
    return {
      money_total: 0,
      // 列表
      list: [],
      loading: false,
      currentPage: 1,
      finished: false,
    };
  },
  methods: {
    // 获取红包数据
    async getData() {
      try {
        this.loading = true;
        const res = await this.$axios.post(`/Redpackets/getRedLog`, {
          page: this.currentPage,
          size: 10,
        });
        this.money_total = res.data.money_total;
        if (res.data && res.data.list.length > 0) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          this.currentPage++;
        }
        this.loading = false;
        if (this.list.length >= Number(res.data.total)) {
          this.finished = true;
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || `获取红包记录失败`,
          duration: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.reward-wrap {
  box-sizing: border-box;
  height: 100vh;
  padding: 29px 0 40px;

  .reward-overview {
    padding: 26px 25px;
    margin: 0 20px;
    color: #fff;
    background: #0f4fb2;
    border: 0 solid #000;
    border-radius: 6px;

    .overview-label {
      margin-bottom: 17px;
      font-size: 17px;
    }

    .overview-count {
      font-size: 27px;
      font-weight: 600;
    }
  }

  .reward-label {
    padding-left: 20px;
    margin-top: 23px;
    font-size: 19px;
    font-weight: 600;
    line-height: 34px;
    color: #333;
  }

  .custom-table {
    .custom-tbody {
      .van-row {
        align-items: start;
        padding: 0 20px;
        margin-top: 23px;
      }

      height: calc(100vh - 120px - 34px - 23px - 29px - 40px);
      overflow: auto;

      .amount-label {
        margin-bottom: 9px;
        font-size: 17px;
        line-height: 17px;
        color: #000;
      }

      .amount-time {
        font-size: 11px;
        line-height: 11px;
        color: #666;
      }

      .amount-value {
        font-size: 17px;
        font-weight: 500;
        color: #ff2c2c;
      }
    }
  }
}
</style>
